export default __webpack_public_path__ + "c426dde14f75300cba70c214c0340553.jpg";